import { useRouteLoaderData } from 'react-router';
import type { Me, SignedInUser } from './api';

// The id of the route whose loader reads /api/me for every signed-in page (routes.tsx).
export const USER_ROUTE = 'user';

export function useMe(): Me {
  const me = useRouteLoaderData(USER_ROUTE) as Me | undefined;
  if (!me) throw new Error('useMe() outside the signed-in routes');
  return me;
}

export const useUser = (): SignedInUser => useMe().user;
